import DataService from "@/services/DataService";

export default {
  getAll() {
    return DataService.apiClient.get("/mailtemplates");
  },

  get(id) {
    return DataService.apiClient.get("/mailtemplates/" + id);
  },

  save(template) {
    if (template._id != null) {
      return DataService.apiClient.patch(
        "/mailtemplates/" + template._id,
        template.data
      );
    } else {
      return DataService.apiClient.post("/mailtemplates", template.data);
    }
  },
  delete(id) {
    return DataService.apiClient.delete("/mailtemplates/" + id);
  }
};
